/**
 * SettingsList: the row list Settings uses for teams, members, keys and
 * tags. A hairline above the list and under each row; no card, no shadow.
 * A row holds its content and, at the right edge, RowAction buttons.
 */

import { cn } from '@/lib/utils'

export function SettingsList({ children }: { children: React.ReactNode }): React.JSX.Element {
  return <ul className="border-t border-border">{children}</ul>
}

export function SettingsListRow({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}): React.JSX.Element {
  return (
    <li
      className={cn(
        'flex min-h-14 items-center gap-3 border-b border-border px-2 py-2 transition-colors hover:bg-muted/50',
        className,
      )}
    >
      {children}
    </li>
  )
}
